/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ModuleControllerCreateModuleCompleteRequestModulePermissionsInner { 
    permissions?: Array<string>;
    companiesAllowed?: Array<string>;
    usersAllowed?: Array<number>;
    companiesDenied?: Array<string>;
    usersDenied?: Array<number>;
    /**
     * Roles (roles.id) con acceso; ausente = no tocar
     */
    rolesAllowed?: Array<number>;
    /**
     * Roles (roles.id) denegados; ausente = no tocar
     */
    rolesDenied?: Array<number>;
}

